import { render, staticRenderFns } from "./CategoryAttributeDialog.vue?vue&type=template&id=a7222f1c"
import script from "./CategoryAttributeDialog.vue?vue&type=script&lang=js"
export * from "./CategoryAttributeDialog.vue?vue&type=script&lang=js"
import style0 from "./CategoryAttributeDialog.vue?vue&type=style&index=0&id=a7222f1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports